import { formatDiffDate, ignoreTimezone } from "@enkor/date-fns";

import { EventCommentReplyV1 } from "@models/data-contracts";

class ReplyViewModel {
  id: number;
  authorName: string;
  authorId: number;
  profileImage?: string;
  content: string;
  commentedAt: string;

  static create(responseData: EventCommentReplyV1) {
    const comment = new ReplyViewModel();

    comment.id = responseData.id;
    comment.authorName = responseData.user.name;
    comment.authorId = responseData.user.id;
    comment.profileImage = responseData.user.url || "";

    comment.content = responseData.text;
    comment.commentedAt = formatDiffDate(
      ignoreTimezone(responseData.createdAt),
    );

    return comment;
  }
}

export default ReplyViewModel;
